<template>
  <div>
    <div class="title">
      <span>研究团队</span>
    </div>
    <div class="list" v-if="flag">
      <div class="group" v-for="group in m" :key="group.id">
        <h2 style="text-align: center">{{ group.name }}</h2>
        <div v-for="i in group.list" :key="i.id" v-show="i.list.length > 0">
          <h3>{{ i.name }}</h3>
          <div class="centerArea">
            <div
              v-for="m in i.list"
              :key="m.id"
              style="margin: 10px"
              @click="toDetail(m)"
            >
              <el-card v-if="m.headImage"  class="ii" :body-style="{ padding: '0px' }">
                <el-image
                  style="width: 200px; height: 260px"
                  :src="m.headImage"
                  fit="cover"
                />
                <div
                  style="
                    padding: 10px;
                    width: 200px;
                    box-sizing: border-box;
                    text-align: center;
                  "
                >
                  {{ m.name }}
                  <br />{{ m.englishName }}
                </div>
              </el-card>
              <div v-else style="width:200px; text-align: center;">
                {{ m.name }}
              </div>
              <!-- <div>
                {{ m.name }}
              </div>
              <div>
                {{ m.name }}
              </div>
              <div>
                {{ m.name }}
              </div>
              <div>
                {{ m.name }}
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { listGroupMember, listPosition } from '@/api/api'
export default {
  data () {
    return {
      groupMemberList: [],
      position: [],
      flag: false
    }
  },
  created () {
    this.listGroupMember()
  },
  methods: {
    toDetail (item) {
      if (!item.description) {
        return
      }
      localStorage.memberDetail = JSON.stringify(item)
      this.$router.push({
        path: '/memberDetail'
      })
    },
    listGroupMember () {
      listGroupMember().then((res) => {
        if (res.code === 200) {
          this.groupMemberList = res.data.reverse()
          console.log(this.groupMemberList)
          this.getlistPosition()
        }
      })
    },
    getlistPosition () {
      listPosition().then((res) => {
        this.position = res.data
        // this.groupMemberList.forEach(i => {
        //   i.position = {...res.data, l: []}
        // })
        // this.groupMemberList.forEach(g => {
        //   g.memberList.forEach(m => {
        //   })
        // })
        let data = []

        this.groupMemberList.forEach((g) => {
          let group = {
            name: g.groupName,
            id: g.groupId,
            list: [
              // {
              //   name: '组1',
              //   id: 123,
              //   list: [
              //     {}
              //   ]
              // }
            ]
          }
          console.log(g.memberList, 123)
          // eslint-disable-next-line no-unused-vars
          let arr = g.memberList.sort((a, b) => {
            return b.sortNum - a.sortNum
          })
          this.position.forEach((p) => {
            let position = {
              name: p.name,
              id: p.id,
              list: []
            }
            g.memberList.forEach((m) => {
              if (p.id === m.positionId) {
                position.list.push(m)
              }
            })
            group.list.push(position)
          })
          data.push(group)
        })
        this.m = data
        console.log(data)
        this.flag = true
      })
    }
  }
}
</script>

  <style scoped>
.title {
  letter-spacing: 1px;
  font-size: 28px;
  line-height: 2em;
  color: #2f4f4f;
  border-bottom: 3px solid #2f4f4f;
  font-weight: bold;
}
h3 {
  border-bottom: 1px solid #ccc;
  line-height: 2em;
  text-align: center;
}
.centerArea {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.group + .group {
  margin-top: 40px;
  border-top: 3px solid #2f4f4f;
}
.ii:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/view/member.vue